import { useLayoutEffect, useState } from "react";
import { computeLines } from "../Utils/lineHelpers";

export default function useBracketLines(
  bracketData,
  games,
  containerRef,
  matchRefs
) {
  const [svgSize, setSvgSize] = useState({
    width: 0,
    height: 0,
  });

  const [lines, setLines] = useState([]);

  useLayoutEffect(() => {
    if (!bracketData || !containerRef.current) return;

    const updateLines = () => {
      if (!containerRef.current) return;

      const rect =
        containerRef.current.getBoundingClientRect();

      setSvgSize({
        width: rect.width,
        height: rect.height,
      });

      const newLines = computeLines(
        bracketData,
        matchRefs,
        rect
      );

      setLines(newLines);
    };

    const frame = requestAnimationFrame(updateLines);

    const resizeObserver = new ResizeObserver(() => {
      requestAnimationFrame(updateLines);
    });

    resizeObserver.observe(containerRef.current);

    Object.values(matchRefs.current).forEach((element) => {
      if (element) {
        resizeObserver.observe(element);
      }
    });

    window.addEventListener("resize", updateLines);

    return () => {
      cancelAnimationFrame(frame);
      resizeObserver.disconnect();
      window.removeEventListener("resize", updateLines);
    };
  }, [bracketData, games, containerRef, matchRefs]);

  return {
    svgSize,
    lines,
  };
}